import { useQuery } from "@tanstack/react-query";

export type MarketState = {
  code: string;
  name: string;
  meta: string;
  merchants?: number;
  selectedMerchantsLabel?: string;
  status: string;
  available: boolean;
  accent: string;
};

const marketsByCountry: Record<string, MarketState[]> = {
  CA: [
    {
      code: "ON",
      name: "Ontario",
      meta: "",
      status: "Licensed",
      available: true,
      accent: "tw:bg-sky-100 tw:text-sky-800",
    },
    {
      code: "BC",
      name: "British Columbia",
      meta: "",
      status: "Licensed",
      available: true,
      accent: "tw:bg-orange-100 tw:text-orange-800",
    },
  ],
  US: [
    {
      code: "CA",
      name: "California",
      meta: "",
      status: "Licensed",
      available: true,
      accent: "tw:bg-sky-100 tw:text-sky-800",
    },
    {
      code: "NY",
      name: "New York",
      meta: "",
      status: "Licensed",
      available: true,
      accent: "tw:bg-orange-100 tw:text-orange-800",
    },
  ],
};

const DEFAULT_COUNTRY = "US";

function normalizeCountry(country: string | null | undefined): string {
  return country?.trim().toUpperCase() ?? DEFAULT_COUNTRY;
}

async function fetchMarketsCatalog(
  country: string | null | undefined,
): Promise<MarketState[]> {
  await new Promise((resolve) => setTimeout(resolve, 50));

  return (
    marketsByCountry[normalizeCountry(country)] ??
    marketsByCountry[DEFAULT_COUNTRY]
  );
}

export function useMarketsCatalog(country: string | null | undefined) {
  return useQuery({
    queryKey: ["markets-catalog", normalizeCountry(country)],
    queryFn: () => fetchMarketsCatalog(country),
  });
}
